<script>
import { mapGetters } from 'vuex';

export default {
  name: 'RoleMixin',
  data() {
    return {
      roles: [
        'User',
        'Admin',
        'Training Officer',
        'Developer',
        'Demonstrator',
        'Ghost',
      ],
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },
  methods: {
    // if current user's roles contain at least one of roles you specified, it will return true
    // Usage: vm.$role(['Admin']) -> return true
    $role(roles = []) {
      if (!this.currentUser) return false;

      roles = roles.map((x) => x.toLowerCase());
      let rolesUnique = [...new Set(roles)];
      return (
        this.currentUser.roles &&
        this.currentUser.roles.some((x) =>
          rolesUnique.includes(x.toLowerCase())
        )
      );
    },
    $getHighestPrivilegedRole(roles) {
      // Define the hierarchy of roles in order from highest to lowest
      const roleHierarchy = [
        'Super Admin',
        'Admin',
        'Training Manager',
        'Trainee',
      ];
      try {
        // Filter out any roles that don't match the known hierarchy
        const validRoles = roles.filter((role) => roleHierarchy.includes(role));
        // If no valid roles are found, return an empty string
        if (validRoles.length === 0) {
          return '';
        }

        // Find the highest privileged role based on its index in the roleHierarchy
        const highestRole = validRoles.reduce((highest, current) => {
          return roleHierarchy.indexOf(current) < roleHierarchy.indexOf(highest)
            ? current
            : highest;
        });

        return highestRole;
      } catch (error) {
        // In case of any error, return an empty string
        return '';
      }
    },
  },
};
</script>
